import map from 'lodash/map'
import React, { FC } from 'react'

import { SpecificationsGroup } from '@Components/Product/Specifications/Group'
import { ProductSpecificationGroup } from '@Generated/graphql'

interface SpecificationsSingleProps {
  groups: ProductSpecificationGroup[]
}

export const SpecificationsSingle: FC<SpecificationsSingleProps> = ({ groups }) => (
  <>
    {map(groups, ({ items, name }) => <SpecificationsGroup key={name} items={items || []} />)}
  </>
)
